import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectStepComponent } from './projectstep.component';
import { ProjectStepRoutes } from './projectstep.routing';
import { SharedModule } from '../../core/shared/shared.module';
import { CustomersListModule } from '../../company/customers/customers-list/customers-list.module';
import { EmployeesModule } from '../../company/employees/employes.module';
import { EmployeesListComponent } from '../../company/employees/employee-list/employees-list.component';
import { CustomersListComponent } from '../../company/customers/customers-list/customers-list.component';

@NgModule({
  imports: [CommonModule, ProjectStepRoutes, SharedModule, CustomersListModule, EmployeesModule],
  entryComponents: [CustomersListComponent, EmployeesListComponent],
  declarations: [ProjectStepComponent],
  exports: [ProjectStepComponent]
})
export class ProjectStepModule { }
